import React from 'react';
import MusicList from './MusicList';

const MusicHistory = () => {
  return (
    <MusicList 
      filterMode="history"
      showQuickCategoryBar={true}
    />
  );
};

export default MusicHistory;

